const styObj = {
  default: {
    '--button-color': '#a338fc',
  },
  echo: {
    '--button-color': '#ff3b30',
  },
  joychat: {
    '--button-color': '#20d887',
  },
  kiko: {
    '--button-color': '#FFEC00',
  },
  vava: {
    '--button-color': '#a338fc',
  },
  vibeo: {
    '--button-color': '#a338fc',
  },
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        // 有配置
        if (styObj[this.packageName]) {
          return styObj[this.packageName]
        }
        // 未配置
        else {
          return styObj['default']
        }
      }
      return {}
    },
  },
}
